<template>
	<div class="column selection-list">
		<SelectionListHeader
			:title="title"
			:tab="tab"
			:mode="mode"
			:searchValueProp="searchValue"
			@search="search"
		/>
		<div class="list-container">
			<div
				class="building-container"
				v-for="(item, index) in listItems"
				:key="item[idName]"
			>
				<div class="group-title">
					<p @click="collapse(item[idName])"> {{ item[displayName] }}</p>
					<div v-if="selectionOptions?.length > 0 && !isAddMode">
						<div class="control item-dropdown">
							<v-select
								class="panel-select header"
								v-model="item.objectOption"
								:options="selectionOptions"
								:allowEmpty="false"
								:internalSearch="false"
								:showLabels="false"
								:searchable="false"
								@select="(event) => selectedItemOptionForGroup(item, event)"
								track-by="value"
								label="name"
							>
								<span slot="noResult">{{ $t('layered_selection.no_results') }}</span>
								<span
									slot="caret"
									slot-scope="{ toggle }"
									class="caret"
									@mousedown.prevent.stop="toggle()"
								><i class="fas fa-caret-down caret-inner" /></span>
							</v-select>
						</div>
					</div>
					<span class="icon" @click="selectGroup(item)" v-if="getSublistElements(item).length > 0 && showAddGroup">
						<i class="fas" :class="isAddMode ? 'fa-plus' : 'fa-minus'" />
					</span>
				</div>
				
				<div
					class="panel-list narrow no-hover"
					v-for="(subItem) in getSublistElements(item)"
					:key="item[idName] + subItem[subIdName]"
				>
					<p class="panel-list-item"> {{ subItem[subDisplayName] && !isAddMode && subItem.buildingName != subItem[subDisplayName] && subItem.buildingName ? `${subItem.buildingName} - ` : `` }} {{ subItem[subDisplayName] }} </p>
					<span class="icon" @click="selectItem(item, subItem, index)">
						<i class="fas" :class="isAddMode ? 'fa-plus' : 'fa-minus'" />
					</span>
				</div>
				<div class="panel-list narrow no-hover" v-if="item[subListName]?.length == 0">
					<p class="header-item">
						{{ $t('layered_selection.all_handled') }}
					</p>
				</div>
				<div v-if="shouldBeCollapsed(item[idName]) && item[subListName]?.length != 0" class="panel-list narrow no-hover">
					<p class="header-item">
						{{ $t('layered_selection.collapsed_rows', { count: item[subListName]?.length ?? 0 }) }}
					</p>
				</div>
			</div>
			<div class="panel-list narrow no-hover" v-if="listItems.length == 0">
				<p class="header-item">
					{{ isAddMode || searchValue ? $t('layered_selection.no_results') : blankSelection }}
				</p>
			</div>
		</div>
		
	</div>
</template>

<script>
import SelectionListHeader from '@/components/SelectionList/SelectionListHeader.vue';

export default {
	components: { SelectionListHeader },
	props: {
		listItems: Array,
		title: String,
		tab: Number,
		mode: String,
		blankSelection: String,
		subListName: String,
		idName: String,
		subIdName: String,
		displayName: {
			type: String,
			default: 'name'
		},
		subDisplayName: {
			type: String,
			default: 'name'
		},
		selectionOptions: Array,
		showAddGroup: Boolean,
		searchValueProp: String
	},
	data() {
		return {
			searchValue: '',
			collapseIds: []
		};
	},
	watch: {
		listItems: {
			handler: function() {
				if (this.selectionOptions) {
					this.listItems.map(item => {
						if (!item.objectOption) {
							item.objectOption = this.selectionOptions.find(option => option.value == item.moveType);
							
							return item;
						}
					});
				}
			}
		}
	},
	computed: {
		isAddMode() {
			return this.mode == 'add' ? true : false;
		}
	},
	methods: {
		collapse(id) {
			let foundIdIndex = this.collapseIds.findIndex(collapseId => collapseId === id);
			
			if (foundIdIndex < 0) {
				this.collapseIds.push(id);
			} else {
				this.collapseIds.splice(foundIdIndex, 1);
			}
		},
		shouldBeCollapsed(id) {
			return this.collapseIds.findIndex(collapseId => collapseId === id) < 0 ? false : true;
		},
		selectItem(item, subitem, index) {
			this.$emit('selectItem', item, subitem, index);
		},
		selectGroup(item) {
			this.$emit('selectGroup', item);
		},
		search(searchValue) {
			this.searchValue = searchValue;
			this.$emit('search', searchValue);
		},
		getSublistElements(list) {
			if (this.shouldBeCollapsed(list[this.idName]))
				return [];
				
			return list[this.subListName];
		},
		selectedItemOptionForGroup(item, option) {
			this.$emit('selectedItemOptionForGroup', item, option.value);
			this.$forceUpdate(); //Vue 2 doesn't notice that the value has changed, so force a refresh.
		}
	},
	created() {
		if (this.selectionOptions) {
			this.listItems.map(item => {
				if (!item.objectOption) {
					item.objectOption = this.selectionOptions.find(option => option.value == item.moveType);
					
					return item;
				}
			});
		}
		
		this.searchValue = this.searchValueProp;
	}
};
</script>

<style lang="scss" scoped>
.item-dropdown {
	margin-right: 1rem;
	margin-left: 1rem;
}

.building-container {
	display: flex;
	flex-direction: column;
	> p {
		font-size: 18px;
	}

	.group-title {
		padding: 5px;
		display: flex;
		justify-content: space-between;
		font-size: 18px;
		.icon {
			cursor: pointer;
			margin-right: 12px;
		}
	}
}

.selection-list {
	min-height: 200px;
	display: flex;
	flex-direction: column;
	
	:first-child {
		flex: 5;
	}
	
	.list-container {
		overflow: auto;
		height: 100%;
	}
}
</style>
